import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";

import PaymentsIcon from "@mui/icons-material/Payments";
import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";

const PaymentPlan = ({ plan, plansInstallments }) => {
  // console.log("plan installments from transaction API", plansInstallments);
  // console.log("plan ---> ", plan);

  const [detailsOpen, setDetailsOpen] = useState(false);
  const [paymentPlanDetails, setPaymentPlanDetails] = useState([]);

  const formatDateDDMMYYYY = (date) => {
    if (!date) return "N/A";
    const d = new Date(date);
    return d.toLocaleDateString("en-GB"); // DD/MM/YYYY
  };

  const formatCurrency = (amount) =>
    new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);

  
  // If you already have paid amount from API, use it instead
  const paidAmount = React.useMemo(() => {
    return plansInstallments[0]?.schedules
      ?.filter((txn) => txn?.execution?.response === "Success")
      ?.reduce((total, item) => total + Number(item?.amount || 0), 0);
    // return 1    /// just for testing harcode paid amount
  }, [plansInstallments]);

  // console.log("paidAmount ", paidAmount);

  const remainingAmount = React.useMemo(() => {
    return (
      plansInstallments[0]?.mandate?.mandateDetails?.totalAmount - paidAmount
    );
  }, [plansInstallments[0]?.mandate?.mandateDetails?.totalAmount, paidAmount]);

  // const progressPercent = React.useMemo(() => {
  //   if (!totalScheduleAmountWithTax) return 0;
  //   return Math.round((paidAmount / totalScheduleAmountWithTax) * 100);
  // }, [paidAmount, totalScheduleAmountWithTax]);

  const planSummary = {
    totalAmount:
      plansInstallments[0]?.mandate?.mandateDetails?.totalAmount || 0,
    paidAmount: paidAmount || 0,
    remainingAmount: remainingAmount || 0,
    // progressPercent: progressPercent,
  };

  // console.log("plan summary ", planSummary);

  const getNextPendingSchedule = (schedules = []) => {
    if (!Array.isArray(schedules) || schedules.length === 0) return null;

    // Find last successful payment index
    const successIndex = schedules.findIndex(
      (s) => s?.execution?.response === "Success",
    );

    // Case 1: Success found → return next schedule if execution is null
    if (successIndex !== -1) {
      const nextSchedule = schedules[successIndex + 1];
      if (nextSchedule?.execution === null) {
        return nextSchedule;
      }
    }

    // Case 2: No success found → return first schedule with execution null
    return schedules.find((s) => s?.execution === null) || null;
  };

  return (
    <>
      {/* CARD */}
      <div
        className="payment-card"
        style={{
          background: "#fff",
          borderRadius: 12,
          padding: 20,
          boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
          marginBottom: 24,
          width: "100%",
          maxWidth: "100%",
          overflow: "hidden",
          boxSizing: "border-box",
        }}
      >
        {/* HEADER */}
        <div
          className="payment-header"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #E0E0E0",
            paddingBottom: 12,
            marginBottom: 20,
            gap: 12,
            flexWrap: "wrap",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <PaymentsIcon
              sx={{
                color: "#1976D2",
                fontSize: "2rem", // Default size for larger screens
                "@media (max-width: 768px)": {
                  fontSize: "2.5rem", // Larger size for mobile
                },
              }}
            />
            <span style={{ fontSize: 16, fontWeight: 600 }}>
              Payment Plan Overview
            </span>
          </div>

          {/* <Button
            variant="outlined"
            size="small"
            startIcon={<InfoIcon />}
            onClick={() => setDetailsOpen(true)}
            sx={{
              textTransform: "none",
              borderRadius: 8,
              fontWeight: 600,
              fontSize: 10,
            }}
            className="payment-details-btn"
          >
            View Details
          </Button> */}
        </div>

        {/* TOP GRID */}
        <div
          className="payment-top-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: 16,
            marginBottom: 24,
          }}
        >
          {[
            { label: "Current Plan", value: " Standard EMI Plan" },
            { label: "Payment Frequency", value: "Bullet" },
            {
              label: "Next Payment",
              value: (() => {
                const nextSchedule = getNextPendingSchedule(
                  plansInstallments[0]?.schedules,
                );

                return nextSchedule
                  ? formatCurrency(nextSchedule.amount || 0)
                  : "-";
              })(),
              highlight: true,
            },

            {
              label: "Next Payment Date",
              value: (() => {
                const nextSchedule = getNextPendingSchedule(
                  plansInstallments[0]?.schedules,
                );

                return nextSchedule
                  ? formatDateDDMMYYYY(nextSchedule.expectedDate || "")
                  : "-";
              })(),
            },
          ].map((item, index) => (
            <div
              key={index}
              style={{
                background: "#F7F7F7",
                borderRadius: 10,
                padding: "16px",
                textAlign: "center",
              }}
            >
              <div style={{ fontSize: 12, color: "#757575", marginBottom: 6 }}>
                {item.label}
              </div>
              <div
                style={{
                  fontSize: 16,
                  fontWeight: 700,
                  color: item.highlight ? "#1565C0" : "#212121",
                  wordBreak: "break-word",
                }}
              >
                {item.value}
              </div>
            </div>
          ))}
        </div>

        {/* PROGRESS */}
        {/* <div style={{ marginBottom: 24 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: 13,
              marginBottom: 8,
              flexWrap: "wrap",
              gap: 6,
            }}
          >
            <span style={{ color: "#757575" }}>Payment Progress</span>
            <span style={{ color: "#1565C0", fontWeight: 600 }}>
              {planSummary.progressPercent.toFixed(1)}% Complete
            </span>
          </div>

          <div
            style={{
              height: 8,
              background: "#E0E0E0",
              borderRadius: 6,
              overflow: "hidden",
            }}
          >
            <div
              style={{
                width: `${planSummary.progressPercent}%`,
                height: "100%",
                background: "linear-gradient(90deg, #1565C0, #2E7D32)",
              }}
            />
          </div>
        </div> */}

        {/* SUMMARY GRID */}
        <div
          className="payment-summary-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: 16,
          }}
        >
          {[
            {
              label: "Total Amount",
              value: planSummary.totalAmount,
              color: "#1565C0",
            },
            {
              label: "Paid Amount",
              value: planSummary.paidAmount,
              color: "#2E7D32",
            },
            {
              label: "Remaining",
              value: planSummary.remainingAmount,
              color: "#ED6C02",
            },
          ].map((item, idx) => (
            <div
              key={idx}
              style={{
                background: "#F7F7F7",
                borderRadius: 10,
                padding: "16px",
                textAlign: "center",
              }}
            >
              <div style={{ fontSize: 18, fontWeight: 700, color: item.color }}>
                {formatCurrency(item.value || 0)}
              </div>
              <div style={{ fontSize: 13, color: "#757575" }}>{item.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* View DETAILS MODAL */}
      {/* <Dialog
        open={detailsOpen}
        onClose={() => setDetailsOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Payment Plan Details – {plan.name}
          <IconButton onClick={() => setDetailsOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ overflowX: "auto" }}>
          <table
            style={{ width: "100%", minWidth: 500, borderCollapse: "collapse" }}
          >
            <thead>
              <tr style={{ background: "#F5F5F5" }}>
                {["Installment", "Amount", "Due Date", "Status"].map((h) => (
                  <th
                    key={h}
                    style={{
                      textAlign: "left",
                      padding: "12px",
                      fontSize: 13,
                      color: "#757575",
                    }}
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {plan.installments.map((inst) => (
                <tr
                  key={inst.number}
                  style={{ borderBottom: "1px solid #E0E0E0" }}
                >
                  <td style={{ padding: "12px" }}>
                    Installment #{inst.number}
                  </td>
                  <td style={{ padding: "12px", fontWeight: 600 }}>
                    {formatCurrency(inst.amount)}
                  </td>
                  <td style={{ padding: "12px" }}>{inst.dueDate}</td>
                  <td style={{ padding: "12px" }}>
                    <span
                      style={{
                        padding: "4px 10px",
                        borderRadius: 12,
                        fontSize: 12,
                        fontWeight: 600,
                        background:
                          inst.status === "paid"
                            ? "#E8F5E9"
                            : inst.status === "upcoming"
                            ? "#E3F2FD"
                            : "#FDECEA",
                        color:
                          inst.status === "paid"
                            ? "#2E7D32"
                            : inst.status === "upcoming"
                            ? "#1565C0"
                            : "#D32F2F",
                      }}
                    >
                      {inst.status.charAt(0).toUpperCase() +
                        inst.status.slice(1)}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </DialogContent>

        <DialogActions sx={{ padding: "16px 24px" }}>
          <Button onClick={() => setDetailsOpen(false)}>Close</Button>
          <Button variant="contained" sx={{ bgcolor: "#1565C0" }}>
            Modify Plan
          </Button>
        </DialogActions>
      </Dialog> */}

      {/* 🔽 MOBILE FIX */}
      <style>{`
        @media (max-width: 900px) {
          .payment-top-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }

        @media (max-width: 600px) {
          .payment-top-grid {
            grid-template-columns: 1fr !important;
          }

          .payment-summary-grid {
            grid-template-columns: 1fr !important;
          }

          .payment-details-btn {
            width: 100%;
          }
        }
      `}</style>
    </>
  );
};

export default PaymentPlan;
